import React, { useState, useEffect, useRef } from "react";
import { InitialContainer, Terminal, Command, MainContainer } from "./styles";
import Card from "../../components/Card";
import TypeAnimation from "react-type-animation";
import { AiFillGithub } from "react-icons/ai";

function Page() {
  return (
    <MainContainer>
      <div className="content">
        <h1 id="title">iLion Root</h1>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            marginTop: "0.5rem",
          }}
        >
          <AiFillGithub size={24} />
          <a
            style={{
              color: "rgba(255,255,255,0.65)",
              textDecoration: "none",
            }}
            href="https://github.com/ilionroot"
            target="_blank"
            rel="noreferrer"
          >
            /ilionroot
          </a>
        </span>
        <div className="cardsContainer">
          <Card
            title="Prime Monitor"
            link="https://primeautomacao.net.br"
            icon={require("../../assets/Prime/logo-white.png")}
            previews={[
              require("../../assets/Prime/preview1.png"),
              require("../../assets/Prime/preview2.png"),
              require("../../assets/Prime/preview3.png"),
            ]}
          />
          <Card
            title="Prime Monitor"
            link="https://primeautomacao.net.br"
            icon={require("../../assets/Prime/logo-white.png")}
            previews={[
              require("../../assets/Prime/preview1.png"),
              require("../../assets/Prime/preview2.png"),
              require("../../assets/Prime/preview3.png"),
            ]}
          />
        </div>
      </div>
    </MainContainer>
  );
}

function Home() {
  const [cursorState, setCursorState] = useState(true);
  const [exitCursorState, setExitCursorState] = useState(true);
  const [initialAnimation, setInitialAnimation] = useState(false);

  let containerRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      setCursorState(false);
    }, 15000);

    setTimeout(() => {
      setExitCursorState(false);
      setTimeout(() => {
        containerRef.current.style.opacity = 0;
        setTimeout(() => {
          setInitialAnimation(true);
        }, 1000);
      }, 1000);
    }, 20000);
  }, []);

  const ContentElement = React.memo(Page, []);

  return !initialAnimation ? (
    <InitialContainer ref={containerRef}>
      <div className="titleContainer">
        <TypeAnimation
          cursor={false}
          sequence={[1000, "iLion Root", 1000, "ilionroot"]}
          wrapper="h1"
        />
      </div>
      <div className="terminalContainer">
        <Terminal>
          <Command>
            <div className="fixArrange">
              $
              <TypeAnimation
                cursor={cursorState}
                sequence={[
                  7000,
                  "wget -r -l 0 https://ilionroot.girhub.io",
                  500,
                  "wget -r -l 0 https://ilionroot.github.io && cd ilionroot.github.io && firefox *.html &",
                ]}
                wrapper="p"
              />
            </div>
            {!cursorState && (
              <>
                <p>[1] 30502</p>
                <br />
                <div className="fixArrange">
                  $
                  <TypeAnimation
                    cursor={exitCursorState}
                    sequence={[3000, "exit"]}
                    wrapper="p"
                  />
                </div>
              </>
            )}
          </Command>
        </Terminal>
      </div>
    </InitialContainer>
  ) : (
    <ContentElement />
  );
}

export default Home;
